import React from 'react';

class FieldLabel extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
    };
  }

  updateValue(value) {
    this.setState(
      { value },
      () => this.props.onChange(this.state.value)
    );
  }

  render() {
    return <div className="mb-3">
      <label htmlFor="label" className="form-label">Label</label>
      <input id="label" name="label"
             type="text"
             className="form-control"
             value={this.state.value || ''}
             onChange={e => this.updateValue(e.target.value)}
             placeholder="Enter a label" />
    </div>
  }

}

export default FieldLabel;
